"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _layout = require("../../layout");

var getDisplay = function getDisplay(inline, force) {
  return (0, _styledComponents.css)(["display:", ";display:", ";"], ((0, _layout.isDefined)(inline) || force) && (inline ? "inline-grid" : "grid"), ((0, _layout.isDefined)(inline) || force) && (inline ? "-ms-inline-grid" : "-ms-grid"));
};

var _default = getDisplay;
exports.default = _default;